import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { branches } from '../data/branches';
export const Branches: React.FC = () => {
  return <section id="branches" className="w-full bg-[#F7F8FA] py-20 md:py-24 scroll-mt-24" data-id="element-123" data-mp="1sbsd2jo72ne1">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-124" data-mp="1ncxwlodp9ax3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-125" data-mp="2k2opjj6ceq0s">
          <div className="lg:col-span-4" data-id="element-126" data-mp="2k3zwtsyzyfwn">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            ease: [0.23, 1, 0.32, 1]
          }} className="font-bold text-[#111827] text-3xl md:text-4xl mb-5" data-id="element-127" data-mp="2g1mnyvoye1vn">
              Branches waarvoor we werken in Noord-Holland Noord
            </motion.h2>
            <p className="text-[#6B7280] text-lg leading-relaxed mb-6" data-id="element-128" data-mp="2yxl40e4qw9mb">
              Onze klanten zijn dienstverlenende bedrijven met één tot tien
              medewerkers. Praktijken, vakbedrijven en kantoren in Dijk en
              Waard, Alkmaar, Heerhugowaard, Schagen en omstreken die het van
              hun regio moeten hebben.
            </p>
            <p className="text-[#6B7280] leading-relaxed" data-id="element-129" data-mp="3oherz7iuhqil">
              Staat jouw branche er niet bij? Dat betekent niet dat het niet
              past. Het zoekgedrag van een hovenier en een uitzendbureau
              verschilt, de aanpak eronder is dezelfde.
            </p>
          </div>

          <div className="lg:col-span-8" data-id="element-130" data-mp="31jbgckt1oc2n">
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-131" data-mp="31kmlany87pvc">
              {branches.map((branch, index) => {
              const Icon = branch.icon;
              const inner = <>
                    <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-[#EEF5FA] text-[#004AC7] flex-shrink-0" data-id="element-132" data-mp="zossyzcye0ju">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-133" data-mp="2cpynrh2kctrw" />
                    </span>
                    <span className="min-w-0 flex-grow" data-id="element-134" data-mp="27puh0irgjdev">
                      <span className="block font-semibold text-[#111827]" data-id="element-135" data-mp="27sgnef2m3mvi">
                        {branch.name}
                      </span>
                      <span className="block text-sm text-[#6B7280] leading-relaxed" data-id="element-136" data-mp="1yq7c3mzirph2">
                        {branch.description}
                      </span>
                    </span>
                  </>;
              return <motion.li key={branch.name} initial={{
                opacity: 0,
                y: 16
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.35,
                delay: Math.min(index, 6) * 0.04,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-137" data-mp="2re38srp39hdu" data-mpi={index}>
                    {branch.slug ? <Link to={`/website-voor/${branch.slug}`} className="group flex items-start gap-4 bg-white rounded-xl border border-gray-200 p-5 h-full hover:border-[#004AC7] transition-colors duration-200" data-id="element-138" data-mp="3abmh1t3q2vz7">
                        {inner}
                        <ArrowRightIcon className="h-4 w-4 text-[#004AC7] flex-shrink-0 mt-1 transform group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true" data-id="element-139" data-mp="3rmrr955p8yw6" />
                      </Link> : <div className="flex items-start gap-4 bg-white rounded-xl border border-gray-200 p-5 h-full" data-id="element-140" data-mp="4i3jp01ctwea">
                        {inner}
                      </div>}
                  </motion.li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
};